import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Checkbox, FormControlLabel, Radio } from '@mui/material';

import styles from './ProductOptionsSelect.module.css';

import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import { UserContext } from '../Contexts/User_Context';
import { TheOrderContext } from '../Contexts/TheOrder_Context';

const ProductOptionsSelect = (props) => {
    const navigate = useNavigate();
    const [mobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction, logout] = useContext(UserContext);
    const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
    const [currentStyle, setCurrentStyle] = useState(mobiOrNot ? styles.mobile : styles.desktop);

    const [checkboxState, setCheckboxState] = useState(() =>
        props.options?.map((element) =>
            element.options.map(() => false)
        )
    );

    const [quantities, setQuantities] = useState(() =>
        props.options?.map((element) =>
            element.options.map(() => 1)
        )
    );

    useEffect(() => {

        let itmINOrd = theOrder.items.filter(item => item._id === props.item._id)[props.indx]

        if (itmINOrd) {
            setCheckboxState(
                itmINOrd.prodOptions?.map((optionGroup) =>
                    optionGroup.options.map((option) => option.selected || false)
                )
            );
            setQuantities(
                itmINOrd.prodOptions?.map((optionGroup) =>
                    optionGroup.options.map((option) => option.mount || 1)
                )
            );
        }
        else {
            setCheckboxState(() =>
                props.options?.map((element) =>
                    element.options.map((_, optIndex) =>
                        element.mustSelect ? optIndex === 0 : false
                    )
                )
            );
            setQuantities(() =>
                props.options?.map((element) =>
                    element.options.map(() => 1)
                )
            );
        }
    }, [theOrder, props.item._id, props.options]);


    const updateChkSelection = (option, optIndex, parentIndex) => {
        setCheckboxState((prevState) =>
            prevState.map((parent, pIndex) => {
                if (pIndex === parentIndex) {
                    const maxSelection = props.options[parentIndex]?.maxSelection || 500;
                    const selectedCount = parent.filter(Boolean).length; // סופרים רק true

                    // אם אנחנו מנסים לסמן אופציה חדשה והגענו למגבלת הבחירה - אל תשנה
                    if (selectedCount >= maxSelection && !parent[optIndex]) {
                        return parent;
                    }

                    // עדכון הבחירה - החלפת מצב ה־checkbox
                    return parent.map((checked, cIndex) =>
                        cIndex === optIndex ? !checked : checked
                    );
                }
                return parent;
            })
        );
    };

    const updateRadioSelection = (optIndex, parentIndex) => {
        setCheckboxState((prevState) =>
            prevState.map((parent, pIndex) => {
                if (pIndex === parentIndex) {
                    return parent.map((_, cIndex) => cIndex === optIndex);
                }
                return parent;
            })
        );
    };

    const updateQuantity = (parentIndex, optIndex, increment) => {
        setQuantities((prevState) =>
            prevState.map((parent, pIndex) => {
                if (pIndex === parentIndex) {
                    const maxSelection = props.options[parentIndex]?.maxSelection || 500;
                    const totalSelected = checkboxState[parentIndex]?.reduce((sum, checked, index) =>
                        checked ? sum + parent[index] : sum
                        , 0);

                    if (totalSelected >= maxSelection && increment > 0) {
                        return parent;
                    }

                    return parent.map((quantity, qIndex) =>
                        qIndex === optIndex ? Math.max(1, quantity + increment) : quantity
                    );
                }
                return parent;
            })
        );
    };

    const saveIt = () => {
        const prodOptions = props.options?.map((element, parentIndex) => ({
            ...element,
            options: element.options.map((option, optIndex) => ({
                ...option,
                selected: checkboxState[parentIndex]?.[optIndex] || false,
                mount: quantities[parentIndex]?.[optIndex] || 1,
            })),
        }));

        const existingItem = theOrder.items.filter(item => item._id === props.item._id)[props.indx];

        const item = {
            // נתחיל עם הפריט המקורי
            ...props.item,
            // נוסיף או נעדכן את ה־mount מהפריט הקיים, או נקבע ל-1 אם לא קיים
            mount: existingItem ? existingItem.mount : 1,
            // נעדכן את האופציות
            prodOptions,
            // נוודא שה-innerIndx נשמר אם הפריט כבר קיים
            innerIndx: existingItem ? existingItem.innerIndx : undefined,
        };

        if (existingItem) {
            const tempOrdIndx = theOrder.items.findIndex((ord) => ord.innerIndx === existingItem.innerIndx);
            if (tempOrdIndx !== -1) {
                theOrder.items[tempOrdIndx] = item;
                updateTheOrd({ ...theOrder });
            }
        }
        else {
            addToTheOrder(item);
        }
        props.saveIt();
    };


    return (
        <div className={""}>
            <div className={`${styles.prodName} biger centerText bold`}>
                {props.item.prodName}
            </div>
            <div className={"claerlineSpacer fullRow"}></div>
            <div className={"dottedLineSpacer fullRow"}></div>
            <div className={"claerlineSpacer fullRow"}></div>
            {props.options?.map((element, parentIndex) => (
                <div key={parentIndex} className={"spaceMargeTop_10"} >

                    <div className={styles.optionName}>
                        {element.optionName}
                    </div>
                    {element.options.map((option, optIndex) => {
                        const isDisabled =
                            (element.maxSelection || 500) &&
                            checkboxState[parentIndex]?.reduce((sum, checked, index) =>
                                checked ? sum + quantities[parentIndex][index] : sum
                                , 0) >= (element.maxSelection || 500) &&
                            !checkboxState[parentIndex][optIndex];

                            let rdbOrNot = element.mustSelect;
                        return (
                            <div key={optIndex} className={styles.formControlRow}>
                                <FormControlLabel
                                    className={styles.FormControlLabel}
                                    control={
                                        (rdbOrNot) ? (
                                            <Radio
                                                checked={checkboxState[parentIndex]?.[optIndex] || false}
                                                onChange={() => updateRadioSelection(optIndex, parentIndex)}
                                            />
                                        ) : (
                                            <Checkbox
                                                checked={checkboxState[parentIndex]?.[optIndex] || false}
                                                onChange={() => updateChkSelection(option, optIndex, parentIndex)}
                                                disabled={isDisabled}
                                            />
                                        )
                                    }
                                    label={<span className={styles.labelText}>{option.servType}</span>}
                                />

                                {parseFloat(option.addToPrice) > 0 && (
                                    <span className={styles.priceText}>
                                        + ₪{parseFloat(option.addToPrice)}
                                    </span>
                                )}

                                {/* {checkboxState[parentIndex]?.[optIndex] && element.chkMoreThenOne && (
                                    <div className={styles.quantityControl}>
                                        <button
                                            className={styles.minusBtn}
                                            onClick={() => updateQuantity(parentIndex, optIndex, -1)}
                                            disabled={quantities[parentIndex][optIndex] <= 1}
                                        >
                                            -
                                        </button>
                                        <span className={styles.quantityDisplay}>
                                            {quantities[parentIndex][optIndex]}
                                        </span>
                                        <button
                                            className={styles.plusBtn}
                                            onClick={() => updateQuantity(parentIndex, optIndex, 1)}
                                            disabled={
                                                (element.maxSelection || 500) &&
                                                quantities[parentIndex]?.reduce((sum, qty, index) =>
                                                    checkboxState[parentIndex][index] ? sum + qty : sum
                                                    , 0) >= (element.maxSelection || 500)
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                )} */}
                            </div>
                        );

                    })}
                </div>
            ))}
            <div className={`${styles.saveBtn} inColorWhite inBackBlue pointing`} onClick={() => saveIt()}>
                <div>שמור</div>
            </div>

        </div>
    );
};

export default ProductOptionsSelect;
